import { DialogTitle, Stack, Typography } from "@mui/material";
import { FC } from "react";

export interface ModalHeaderProps {
  title: string;
  subtitle: string;
}

const ModalHeader: FC<ModalHeaderProps> = ({ title, subtitle }) => {
  return (
    <DialogTitle
      sx={{
        px: { xs: 2, sm: 3 },
        py: { xs: 1.5, sm: 0 },
        position: { xs: "sticky", sm: "static" },
        top: 0,
        zIndex: 1,
        bgcolor: "brandBackground.primary",
        borderBottom: { xs: "1px solid", sm: "none" },
        borderColor: "divider",
      }}
    >
      <Stack direction="column">
        <Typography
          variant="headingMD"
          fontWeight={600}
          sx={{ fontSize: { xs: 20, sm: 28 }, pr: 4 }}
        >
          {title}
        </Typography>
        <Typography
          variant="textMD"
          color="brandText.secondary"
          sx={{ fontSize: { xs: 13, sm: 16 } }}
        >
          {subtitle}
        </Typography>
      </Stack>
    </DialogTitle>
  );
};

export default ModalHeader;
